import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  entries: [],
  userEntries: [],
  userViewEntries: [],
  userLastEntries: [],
  entryStatus: "idle",
  error: null,
};

export const getEntries = createAsyncThunk("entries/getEntries", async () => {
  const response = await axios.get(`${process.env.REACT_APP_API_ENDPOINT}/api/Entry`);
  return response.data;
});

export const getUserViewEntries = createAsyncThunk("entries/getUserViewEntries", async (userId) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_ENDPOINT}/api/Entry/UserViewEntries/${userId}`
  );
  return response.data ?? [];
});

export const getUserLastEntries = createAsyncThunk(
  "entries/getUserLastEntries",
  async ({ userId, number }) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_ENDPOINT}/api/Entry/GetUserLastEntries/${userId}/${number}`
    );
    return response.data ?? [];
  }
);

export const entriesSlice = createSlice({
  name: "entries",
  initialState,
  reducers: {
    resetEntryStatus: (state) => {
      state.entryStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEntries.pending, (state) => {
      state.entryStatus = "loading entries";
    });
    builder.addCase(getEntries.fulfilled, (state, action) => {
      state.entryStatus = "entries loaded";
      state.entries = action.payload;
    });
    builder.addCase(getEntries.rejected, (state, action) => {
      state.entryStatus = "loading entries failed";
      state.error = action.error.message;
    });
    builder.addCase(getUserViewEntries.pending, (state) => {
      state.entryStatus = "loading user view entries";
    });
    builder.addCase(getUserViewEntries.fulfilled, (state, action) => {
      state.entryStatus = "user view entries loaded";
      state.userViewEntries = action.payload;
    });
    builder.addCase(getUserViewEntries.rejected, (state, action) => {
      state.entryStatus = "loading user view entries failed";
      state.error = action.error.message;
    });
    builder.addCase(getUserLastEntries.pending, (state) => {
      state.entryStatus = "loading user last entries";
    });
    builder.addCase(getUserLastEntries.fulfilled, (state, action) => {
      state.entryStatus = "user last entries loaded";
      state.userLastEntries = action.payload;
    });
    builder.addCase(getUserLastEntries.rejected, (state, action) => {
      state.entryStatus = "loading user last entries failed";
      state.error = action.error.message;
    });
  },
});

export default entriesSlice.reducer;

export const selectAllEntries = (state) => state.entries.entries;

export const selectUserEntries = (state) => state.entries.userEntries;
export const selectUserLastEntries = (state) => state.entries.userLastEntries;
export const selectUserViewEntries = (state) => state.entries.userViewEntries;
